import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";

export default function PlansButtons(props: any) {

    const {
        plans,
        billingCycle,
        handlePlanChange,
        activePlan,
        setOpenDialog
    } = props;

    /*============================
    FORMAT PRICE
    ============================*/
    const formatPrice = (price: number) => {
        if (Number(price) === 0) {
            return <div className="plan_price_flex">
                <span className="plan_price-highlight">Free</span>
            </div>
        }
        
        return (
            <div className="plan_price_flex">
                <span className="plan_price-highlight">${price}</span>
                <div className="plan_price_currency">
                    <span className="plan_price-superscript">USD</span>
                    <span className="plan_price_cycle">/ mo</span>
                </div>
            </div>
        );
    };
    
    
    return (
        <>
        <div id='plan_buttons' className="plans_container transfer_plans_container">
            <RadioGroup 
                className="plans_group" 
                value={activePlan} 
                onChange={(e) => handlePlanChange(e.target.value)}
            >
                {plans.map((plan: any, index: number) => {
                    const monthlyPrice = billingCycle === 'yearly' 
                        ? plan.yearly.price / 12 
                        : plan.monthly.price;
                    
                    const type_of_change = billingCycle === 'yearly' ? plan.yearly.type_of_change : plan.monthly.type_of_change;

                    return (
                        <div 
                            key={index} 
                            className={`plan_item ${Number(activePlan) === Number(plan.plan_id) ? 'is_featured plan_selected' : ''}`}
                        >
                            <FormControlLabel
                                value={plan.plan_id}
                                control={
                                    <Radio 
                                        sx={{
                                            display: 'none' // Hide the radio button visually
                                        }}
                                    />
                                }
                                label={
                                    <div className="plan_container">
                                        <span className="plan_name">{plan.plan_name}</span>
                                        <span className="plan_s_description">{plan.short_description}</span>
                                        <span className="plan_description">{plan.description}</span>
                                        {formatPrice(monthlyPrice)}
                                        <div className="plan_status">
                                            <span className="plan_type_change">{type_of_change}</span>
                                        </div>
                                    </div>
                                }
                                className="plan_form_control_full"
                                sx={{
                                    margin: 0,
                                    width: '100%',
                                    cursor: 'pointer'
                                }}
                            />
                        </div>
                    );
                })}
            </RadioGroup>
        </div>

        <div className="plan_accept_button_container">
            <Button 
                variant="contained"
                onClick={() => {
                    console.log("Selected plan:", activePlan); // Debug log
                    if (activePlan) {
                        // Find the selected plan and calculate price immediately
                        const selectedPlan = plans.find((plan: any) => plan.plan_id == activePlan);
                        if (selectedPlan) {
                            const price = billingCycle === 'yearly' 
                                ? selectedPlan.yearly.price 
                                : selectedPlan.monthly.price;
                            console.log("Calculated price:", price, "Billing cycle:", billingCycle); // Debug log
                        }
                        handlePlanChange(activePlan); // Ensure plan is properly set
                        // Add a small delay to ensure state updates before opening dialog
                        setTimeout(() => {
                            setOpenDialog(true);
                        }, 100);
                    }
                }}
                disabled={!activePlan}
                sx={{
                    backgroundColor: activePlan ? '#7963FF' : '#ccc',
                    color: 'white',
                    padding: '12px 24px',
                    fontSize: '20px !important'
                }}
            >
                Accept Transfer
            </Button>
        </div>
        </>
    )
}





